
export const customEvents = {
    field: {
        validation: 'fjs.field:validation'
    },
    form: {
        destroy:    'fjs.form:destroy',
        init:       'fjs.form:init',
        validation: 'fjs.form:validation'
    }
}
